import type { Timestamp } from '@ka-nabellinc/tcg-platform-proto/gen/ts/google/protobuf/timestamp';

export const timestampToDate = (timestamp: Timestamp): Date => {
  const seconds = Number(timestamp.seconds);
  return new Date(seconds * 1000);
};
